// Extend Window type for analytics libraries
declare global {
    interface Window {
        plausible?: any;
        gtag?: (...args: any[]) => void;
        dataLayer?: any[];
    }
}

import { watch } from 'vue';
import { useCookieConsent } from './composables/useCookieConsent';

// Function to initialize Plausible Analytics
function initPlausible(): void {
    // Check if analytics is already initialized
    if (window.plausible) {
        return;
    }

    // Create script for Plausible
    const script = document.createElement('script');
    script.src = 'https://plausible.io/js/script.js';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-domain', window.location.hostname);

    // Add script to head
    document.head.appendChild(script);

    // console.log('Plausible Analytics initialized');
}

// Function to initialize Google Analytics 4
function initGA4(): void {
    // Check if analytics is already initialized
    if (window.gtag) {
        return;
    }

    // Create tags for Google Analytics
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
    script.async = true;

    // Add script to head
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
        window.dataLayer!.push(args);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'GA_MEASUREMENT_ID');

    // console.log('Google Analytics 4 initialized');
}

/**
 * Initialize analytics based on user consent
 */
export function initAnalytics(): void {
    const { hasConsentFor, consent } = useCookieConsent();

    // Check if there is consent for analytics
    if (hasConsentFor('analytics')) {
        // Initialize analytics services
        initPlausible();
        initGA4(); // Uncomment if needed

        // console.log('Analytics initialized with user consent');
    } else {
        // console.log('Analytics not initialized - no user consent for analytics');
    }

    // Add watcher to track consent changes
    watch(consent, (newConsent) => {
        if (newConsent === 'all') {
            // Initialize analytics when consent is given
            initPlausible();
            initGA4(); // Uncomment if needed

            // console.log('Analytics initialized after consent change');
        } else if (newConsent === 'necessary' || newConsent === 'unknown') {
            // Disable analytics when consent is withdrawn (if possible)
            // console.log('Analytics disabled due to consent change');
        }
    });
}